module.exports = "/images/vendor/vue-paycard/src/5.jpg?f625b53940207cde0202a3db3b2592b8";